import React, { useRef } from 'react';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
//import { PROPERTYID, WIDGETID,  } from '../../api/Globals';

const Tawk = () => {

    const tawkMessengerRef = useRef();

    const onLoad = () => {
        console.log("onLoad works tawkMessengerRef!")
    }

    return (
        <TawkMessengerReact 
            propertyId="6297a2b77b967b1179926a40"
            widgetId="1g4g577q9"
            ref={tawkMessengerRef}
            onLoad={onLoad}
        />
    );
}

export default Tawk;